import React from 'react';
import { OutboundOrderItem } from '../../../../api/warehouse/generated/src';
// import { OrderItem } from '../../types';

interface QuantityModalProps {
  item: OutboundOrderItem;
  qtyInput: string;
  onQtyChange: (value: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export const QuantityModal: React.FC<QuantityModalProps> = ({
  item,
  qtyInput,
  onQtyChange,
  onConfirm,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h3 className="text-lg md:text-xl font-bold mb-2">Menge anpassen</h3>
        <p className="text-gray-700 mb-4 text-sm md:text-base">{item.description}</p>
        
        <div className="mb-4">
          <label className="block text-sm font-semibold mb-2">
            Gepickte Menge (Soll: {item.requiredQty - item.shippedQty})
            {item.shippedQty > 0 && (
              <span className="text-blue-600 ml-2">({item.shippedQty} bereits verschickt)</span>
            )}
          </label>
          <input
            type="number"
            value={qtyInput}
            onChange={(e) => onQtyChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && qtyInput) {
                onConfirm();
              }
            }}
            placeholder="Menge eingeben"
            className="w-full p-3 border-2 border-blue-500 rounded-lg text-lg"
            autoFocus
            min="0"
            max={item.requiredQty - item.shippedQty}
          />
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-semibold hover:bg-gray-400 transition"
          >
            Abbrechen
          </button>
          
          <button
            onClick={onConfirm}
            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            ✓ Bestätigen
          </button>
        </div>
      </div>
    </div>
  );
};